import { defineQuery, defineQueryOptions } from '@pinia/colada'
import type { PaAPI } from '@rialtic/types'
import { STALE_TIME } from '~/queries/query.helpers'

export const WORKSPACE_QUERY_KEYS = {
  root: ['paapi', 'workspace'] as const,
  byId: (id: string) => [...WORKSPACE_QUERY_KEYS.root, id] as const,
}

export const workspaceQuery = defineQueryOptions({
  key: WORKSPACE_QUERY_KEYS.root,
  query: () => {
    const client = useRequestFetch()
    return client<PaAPI.Get['/workspace']>('/api/paapi/workspace')
  },
  staleTime: STALE_TIME.FIVE_MINUTES,
})
export const useWorkspaces = defineQuery(workspaceQuery)

export const workspaceByIdWithConnectors = defineQueryOptions((id: string) => {
  return {
    key: [...WORKSPACE_QUERY_KEYS.byId(id), 'with-connectors'],
    enabled: Boolean(id),
    query: () => {
      const client = useRequestFetch()
      return client<PaAPI.Get['/workspace/{id}']>(
        `/api/paapi/workspace/${id}` as const,
        {
          query: { 'include-connectors': true },
        },
      )
    },
    staleTime: STALE_TIME.FIVE_MINUTES,
  }
})
